// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal */
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f7fa;
    padding: 20px;
  }
  
  /* Card de login */
  .login-box {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 40px;
    width: 100%;
    max-width: 400px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .login-box:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  }
  
  /* Título */
  .login-title {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: 600;
  }
  
  /* Formulário */
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  /* Grupos de formulário */
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .form-label {
    color: #34495e;
    font-size: 14px;
    font-weight: 500;
  }
  
  .form-input {
    padding: 12px 15px;
    border: 1px solid #dfe6e9;
    border-radius: 6px;
    font-size: 15px;
    transition: border-color 0.3s ease;
  }
  
  .form-input:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
  }
  
  /* Botão */
  .login-button {
    background-color: #3498db;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px;
  }
  
  .login-button:hover {
    background-color: #2980b9;
  }
  
  .login-button:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
  
  .login-error {
    background-color: #ffebee;
    color: #c62828;
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-left: 4px solid #c62828;
    animation: fadeIn 0.3s ease-in-out;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  /* Responsividade */
  @media (max-width: 480px) {
    .login-box {
      padding: 30px 20px;
    }
    
    .login-title {
      font-size: 20px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/login/stylesLogin.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,qDAAqD;EACvD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,WAAW;EACX;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,UAAU;EACV;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;EAC7C;;EAEA,mBAAmB;EACnB;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* Container principal */\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #f5f7fa;\n    padding: 20px;\n  }\n  \n  /* Card de login */\n  .login-box {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    padding: 40px;\n    width: 100%;\n    max-width: 400px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .login-box:hover {\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);\n  }\n  \n  /* Título */\n  .login-title {\n    color: #2c3e50;\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 24px;\n    font-weight: 600;\n  }\n  \n  /* Formulário */\n  .login-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  /* Grupos de formulário */\n  .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .form-label {\n    color: #34495e;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  \n  .form-input {\n    padding: 12px 15px;\n    border: 1px solid #dfe6e9;\n    border-radius: 6px;\n    font-size: 15px;\n    transition: border-color 0.3s ease;\n  }\n  \n  .form-input:focus {\n    outline: none;\n    border-color: #3498db;\n    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n  }\n  \n  /* Botão */\n  .login-button {\n    background-color: #3498db;\n    color: white;\n    border: none;\n    padding: 12px;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 10px;\n  }\n  \n  .login-button:hover {\n    background-color: #2980b9;\n  }\n  \n  .login-button:disabled {\n    background-color: #bdc3c7;\n    cursor: not-allowed;\n  }\n  \n  .login-error {\n    background-color: #ffebee;\n    color: #c62828;\n    padding: 12px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    border-left: 4px solid #c62828;\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n  }\n  \n  /* Responsividade */\n  @media (max-width: 480px) {\n    .login-box {\n      padding: 30px 20px;\n    }\n    \n    .login-title {\n      font-size: 20px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
